function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.48 1a.726.726 0 00-.72.828v4.265a.727.727 0 101.453 0V3.488L6.694 6.97a.726.726 0 101.027-1.028L4.24 2.46h2.605a.726.726 0 100-1.453H2.572A.728.728 0 002.479 1zM17 1a.727.727 0 00-.081.007h-4.264a.726.726 0 100 1.453h2.605L11.78 5.942a.726.726 0 101.027 1.028l3.481-3.482v2.605a.726.726 0 101.453 0V1.826A.726.726 0 0017 1zm-9.806 9.808a.726.726 0 00-.5.22L3.213 14.51v-2.605a.726.726 0 10-1.453 0v4.248a.727.727 0 00.837.837h4.248a.726.726 0 100-1.453H4.24l3.481-3.482a.727.727 0 00-.527-1.247zm5.091 0a.726.726 0 00-.506 1.247l3.481 3.482h-2.605a.727.727 0 100 1.453h4.248a.725.725 0 00.837-.837v-4.248a.726.726 0 10-1.453 0v2.605l-3.481-3.482a.726.726 0 00-.52-.22z",
  fill: "#000"
}));